import React, { Fragment, useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../Pages/login/login";
import InsightsPage from "../Pages/InsightsPage/insightsPage";
import Settings from "../Layouts/setting/Settings";
import RoundLoader from "../Components/loader/Loader";
import Quotes from "../Components/quotes/quotes";
import { UserContext, UserPayload } from "../Context/userContext";
import ThreePS from "../Pages/threePS/threePs";
import BasicTabs from "../Pages/tabs/tabsPage";
import ThirdPartyQuestionnaire from "../Pages/thirdPartyQuestionnarie/thirdPartyQuestionnaire";
import OuterLayout from "../Layouts/outerLayout/outerLayout";
import InsightsDetails from "../Pages/insights/insightsDetails";
import Agencies from "../Pages/agencies/agencies";
import InsightsWrapper from "../Layouts/InsightPageLayout/insightPageWrapper";
import ThirdPartyQuestionnaireLayout from "../Layouts/ThirdPartyQuestionnaireLayout/ThirdPartyQuestionnaireLayout";
import ThirdPartyQuestionsSubmittedSuccessfully
    from "../Components/ThirdPartyQuestionnaire/thirdPartyQuestionSubmittedSuccessfully/index";
import EscalatedPage from "../Pages/escalatedPage/escalatedPage";
import GlobalDialogBox from "../Components/global/GlobalDialogBox/GlobalDialogBox";
import CreateEscalation from "../Components/CreateEscalation/CreateEscalation";
import { useInsights } from "../Context/insightContext";
import { useInsightsUtils } from "../hooks/useInsightsUtils";
import NotFound from "../Pages/notFound/notFound";
import { ConfigProvider } from "antd";
import { useRoles } from "../hooks/useRoles";
import { PublicOnlyRoute } from "../guards/publicOnlyRoute";
import { ProtectedRoute } from "../guards/protectedRoute";
import { useEnvironmentDetection } from "../hooks/useEnvironmentDetection";
import { usePostAuthRedirect } from "../hooks/usePostAuthRedirect";
import { ThreePsCodes } from "../Pages/threePsCodes/threePsCodes.index";
import { ANTD_THEME_CONFIG } from "../constants/defaultValues";
import Agents from "../Pages/agents/agents.index";
import EditAgent from "../Pages/agents/components/editAgent/editAgent.index";

const RoutesComponent = () => {
    const { userDetail, showLoader } = useContext(UserContext) as UserPayload;
    const { escalationDialogInfo } = useInsights();
    const { ResetEscalationDialogBoxData } = useInsightsUtils();
    const roles = useRoles(userDetail);

    useEnvironmentDetection();
    usePostAuthRedirect();

    return (
        <Fragment>
            {showLoader && <RoundLoader />}
            {escalationDialogInfo !== null &&
                <GlobalDialogBox
                    sizeType={'lg'}
                    flagNoPadding={true}
                >
                    <CreateEscalation
                        escalationDialogInfo={escalationDialogInfo}
                        handleCloseEscalationPopUp={escalationDialogInfo.handleCloseEscalationPopUp ?? ResetEscalationDialogBoxData}
                    />
                </GlobalDialogBox>
            }
            <Routes>
                <Route path="/" element={
                    <PublicOnlyRoute>
                        <Login />
                    </PublicOnlyRoute>
                } />
                <Route path="/third-party-questionnaire" element={<ThirdPartyQuestionnaireLayout />}>
                    <Route index element={<ThirdPartyQuestionnaire />} />
                    <Route path="success" element={<ThirdPartyQuestionsSubmittedSuccessfully />} />
                </Route>
                <Route path="/third-party-questionnarie" element={<Navigate to="/third-party-questionnaire" />} />
                <Route path="/third-party-questionnarie/success" element={<Navigate to="/third-party-questionnaire/success" />} />
                <Route element={
                    <ConfigProvider theme={ANTD_THEME_CONFIG}>
                        <ProtectedRoute>
                            <OuterLayout />
                        </ProtectedRoute>
                    </ConfigProvider>
                    }
                >
                    <Route path="/insights" element={<InsightsWrapper />}>
                        <Route index element={<InsightsPage />} />
                        <Route path="moreInfo" element={<InsightsDetails />} />
                    </Route>
                    <Route path="/agents">
                            <Route index element={<Agents />} />
                            <Route path="agent" element={<EditAgent />} />
                    </Route>
                    <Route
                        path="/escalated"
                        element={<EscalatedPage />}
                    />
                    <Route
                        path="/threepscodes"
                        element={<ThreePsCodes />} 
                    />
                    <Route path="/agencies" element={<Agencies />} />
                    {roles.quotes && <Route path="/quotes" element={<Quotes />} />}
                    {roles.settings && (
                        <Route path="/settings" element={<Settings />}>
                            <Route
                                index
                                element={roles.lnid ? <BasicTabs /> : <ThreePS />} />
                            {roles.lnid && <Route path="LNID" element={<BasicTabs />} />}
                            {roles.threeps && <Route path="3PS" element={<ThreePS />} />}
                        </Route>
                    )}
                    <Route path="*" element={<Navigate to="/insights" replace/>} />
                </Route>
                <Route path="not-found" element={<NotFound />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Fragment >
    );
};

export default RoutesComponent;
